import React from 'react';
import PropTypes from 'prop-types';
import {withRouter} from 'react-router-dom';


class FeedbackItem extends React.Component {

    constructor(props) {
        super(props);

        const {title = '', audio = '', feedback_type = '', val = ''} = this.props.node;

        this.state = {
            title: title,
            audio: audio,
            feedback_type: feedback_type,
            val: val,
            visible: false
        };
    }

    componentDidMount(){

        document.addEventListener('jre-text-times-up', this.timesUpEvent);
        document.addEventListener('jre-mt-invisible', this.mtInvisibleEvent);
    }

    hide() {
        this.setState({visible: false});
    }

    show() {
        this.setState({visible: true});
    }


    customstopaudio(){                           
        // console.log(this.mainaudio);
        // if(this.mainaudio != null){
        //     this.mainaudio.pause();   
        // }
        // this.mainaudio.pause();
        
        let main = localStorage.getItem('audioevent');
        const doc = new DOMParser().parseFromString(main, 'text/html');
        // console.log(doc.body.firstChild);            
        // this.mainaudio = doc.body.firstChild;
        // this.mainaudio.pause();
        // console.log('pause');
        doc.body.firstChild.setAttribute("id", "mainaudio");
        doc.body.firstChild.pause();
        doc.body.firstChild.currentTime = 0;            
        // console.log(doc.body.firstChild);
        doc.body.firstChild.removeAttribute("autoplay");
        setTimeout(()=>{
            // var a = document.getElementById("mainaudio");  
            var a = document.getElementsByTagName("audio");  
            // console.log(a[0]);
            a[0].removeAttribute("autoplay");
            a[0].pause();
            // console.log(doc.body.firstChild);
        },100)               
        // console.log(main);
        // let mains = main.outerHTML;
        // console.log(mains);
        // main.html(main);
        // main.pause();                       
    }

    check(check,audio){
        // console.log(check);           
        // console.log(audio);       
        // if (check.parentNodeType !== 'ce-button' && audio != null) {    
        //     console.log('assiged');
        //     this.mainaudio = audio;
        //     console.log(audio);
        //     localStorage.setItem('audioevent',audio.outerHTML);
        // }
        if(audio != null){
            localStorage.setItem('audioevent',audio.outerHTML);
            // this.customstopaudio();    
        }
    }

    render() {
        const {moduleURL = ''} = this.props;
        const {val, audio} = this.state;     
        // console.log(this.audio);   
        return (
            <div>
                <div dangerouslySetInnerHTML={{__html:val}} />
                {audio && <audio ref={(audio) => {this.check(this.props,audio);this.audio=audio}} autoPlay={true} onPlay={this.props.onAudioStart}
                                 onEnded={this.props.onAudioEnded}>
                    <source src={`${moduleURL}/media/${audio}`} />
                </audio>}
            </div>
        );
    }
}

FeedbackItem.propTypes = {
    node: PropTypes.object.isRequired
};

export default withRouter(FeedbackItem);



// WEBPACK FOOTER //
// ./src/js/components/app/jre/elements/feedback-item-node.js